import { Box } from '@websolutespa/bom-mixer-ui';
import styled from 'styled-components';
import { animatedUnderline, clampValue } from '../../utils/utils';

export const CtaContainer = styled(Box)`
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-2);
  padding: var(--spacing-2) var(--spacing-4);
  height: ${clampValue(3.6, 4)};
  /* text-transform: lowercase; */
  justify-content: center;
  cursor: pointer;
  transition:
    background-color 0.3s ease,
    color 0.3s ease;

  &.-icon-left {
    flex-direction: row-reverse;
  }

  i {
    display: block;
    flex-shrink: 0;
    width: 2rem;
    height: 2rem;
    svg {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  &.-primary {
    background-color: var(--color-background-secondary);
    color: var(--color-foreground-secondary);
    font-style: normal;
    @media (hover: hover) {
      &:hover {
        background-color: var(--color-background-secondary-accent);
        color: var(--color-foreground-secondary-accent);
        font-style: italic;
      }
    }
    &.-contrast {
      background-color: var(--color-background-primary);
      color: var(--color-foreground-primary);
      @media (hover: hover) {
        &:hover {
          background-color: var(--color-background-primary-accent);
          color: var(--color-foreground-primary-accent);
          font-style: italic;
        }
      }
    }
  }

  &.-secondary {
    background-color: transparent;
    border: 1px solid var(--color-border-primary);
    color: var(--color-foreground-primary);
    font-style: normal;
    @media (hover: hover) {
      &:hover {
        background-color: var(--color-background-secondary);
        color: var(--color-foreground-secondary-accent);
        font-style: italic;
      }
    }
    &.-contrast {
      border: 1px solid var(--color-border-secondary);
      color: var(--color-foreground-secondary);
      @media (hover: hover) {
        &:hover {
          background-color: var(--color-background-primary-accent);
          color: var(--color-foreground-primary-accent);
          font-style: italic;
        }
      }
    }
  }

  &.-ghost {
    background-color: transparent;
    border: none;
    color: var(--color-foreground-primary);
    @media (hover: hover) {
      &:hover {
        background-color: var(--color-background-secondary);
        color: var(--color-foreground-secondary-accent);
      }
    }
  }

  &.-link,
  &.-link-reverse {
    background-color: transparent;
    color: var(--color-foreground-primary);
    padding: var(--spacing-2) 0;
    font-style: normal;

    span {
      ${animatedUnderline('1px', '0.5s', 'rtl')}
      display: inline;
      padding-block: var(--spacing-1);
      background-size: 100% 1px;
    }
    @media (hover: hover) {
      &:hover {
        color: var(--color-foreground-primary-accent);
        font-style: italic;
        span {
          background-size: 0% 1px;
        }
      }
    }

    &.-contrast {
      color: var(--color-foreground-secondary);
      @media (hover: hover) {
        &:hover {
          color: var(--color-foreground-secondary-accent);
        }
      }
    }
  }

  &.-link-reverse {
    span {
      ${animatedUnderline('1px', '0.5s', 'ltr')}
      display: inline;
      padding-block: var(--spacing-1);
      background-size: 0% 1px;
    }
    @media (hover: hover) {
      &:hover {
        span {
          background-size: 100% 1px;
        }
      }
    }
  }

  &.-icononly {
    width: 3.2rem;
    height: 3.2rem;
    padding: 0;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    &.-secondary {
      border: 1px solid var(--color-border-secondary-accent);
      @media (hover: hover) {
        &:hover {
          border: 1px solid var(--color-border-primary);
        }
      }
    }
    &.-ghost {
      border: none;
    }
  }
`;
